import request from '../utils/request'

/**
 * 获取指定桥梁下激光的当前状态
 * @param {number} bridgeId 桥梁ID
 * @param {number} deviceId 激光设备ID（可选，传则只返回该设备）
 */
export const getLaserStatus = (bridgeId, deviceId) => {
  const params = { bridgeId }
  if (deviceId) {
    params.deviceId = deviceId
  }
  return request({
    url: '/laser-status',
    method: 'get',
    params
  })
}
